import React, { useMemo, useState } from "react";
import PermissionButton from "../../../shared/PermissionButton";
import { useAssessment } from "../../../../hooks/useAssessment";
import Pagination from "../../../../../../components/UI/Pagination";
import { Spinner } from "reactstrap";
import Assessment from "./Assessment";

const ListAssessment = ({ name }) => {
  const [pageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState(null);

  const { loading, assessments, totalRecordsCount, refetchAssessment } =
    useAssessment(pageSize);

  //fetch all assessment for aggregation config
  const { assessments: allAssessments } = useAssessment();
  const assessmentConfig = useMemo(() => {
    const map = {};

    if (allAssessments?.length > 0) {
      allAssessments.forEach((item) => {
        map[item?.id] = item;
      });
    }

    return map;
  }, [allAssessments]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    refetchAssessment(page);
  };

  const handleNextPage = () => {
    const totalPages = Math.ceil(totalRecordsCount / pageSize);
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      refetchAssessment(nextPage);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      refetchAssessment(currentPage - 1);
    }
  };

  return (
    <>
      <div className="arr-content">
        <div className="arr-heading">
          <h1>List Assessment</h1>
          <div className="arr-btns-group">
            <PermissionButton
              moduleName={"Recording Setup"}
              widgetName={name}
              header={"List Assessment"}
              activityName={"select-assessment"}
            />
          </div>
        </div>

        {loading ? (
          <div className="new-spinner-container">
            <div className="new-spinner">
              <div className="loader">
                <Spinner color="primary" />
              </div>
              <div style={{ fontSize: "16px", marginTop: "15px" }}>
                Please wait !! Processing.....
              </div>
            </div>
          </div>
        ) : assessments?.length > 0 ? (
          <div>
            {assessments?.map((item) => (
              <Assessment
                key={item.id}
                assessment={item}
                currentPage={currentPage}
                pageSize={pageSize}
                isOpen={isOpen}
                name={name}
                assessmentConfig={assessmentConfig}
                totalRecordsCount={totalRecordsCount}
                setCurrentPage={setCurrentPage}
                refetchAssessment={refetchAssessment}
                setIsOpen={setIsOpen}
              />
            ))}
          </div>
        ) : (
          <div className="empty-data">No Data found</div>
        )}

        <div
          className="modern-pagination"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "48px",
          }}
        >
          <Pagination
            type="modern"
            itemsCount={totalRecordsCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            nextPage={handleNextPage}
            previousPage={handlePreviousPage}
          />
        </div>
      </div>
    </>
  );
};

export default ListAssessment;
